export default "__VITE_ASSET__xusq4zCA__"